module.exports = __webpack_public_path__ + "static/media/fm.2c13a5d4.svg";